<a href="/">
    <img *ngIf="!appSession.tenant || !appSession.tenant.HasLogo()" alt="Logo" [src]="defaultLogo" [class]="imageClass" />
    <img
        *ngIf="appSession.tenant && appSession.tenant.HasLogo()"
        [src]="
            remoteServiceBaseUrl +
            '/TenantCustomization/GetTenantLogo?skin=' +
            skin +
            '&tenantId=' +
            appSession.tenant.id + '&logoId='+appSession.tenant.LogoId(this.skin)
        "
        alt="Logo"
        [class]="imageClass"
    />
</a>
